module.exports = __webpack_public_path__ + "static/media/Sy_for_Dummies1.bea3f92c.jpeg";